<template>
  <VBlock class="toast-alert">
    <VToast :text="text" />
  </VBlock>
</template>

<script>
import VToast from '@/presentationals/v2/components/layouts/molecules/VToast'
import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'

export default {
  name: 'ToastAlert',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  components: {
    VToast,
    VBlock
  }
}
</script>

<style lang="scss" scoped>
.toast-alert {
  width: 100%;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
}
</style>